module.exports = __webpack_public_path__ + "static/img/ppp.77ddbc5a.png";